<template>
  <div>
    <v-tabs v-model="tabs" centered>
      <v-tab :disabled="!selectedBetfairId.id" class="caption"> Betslip </v-tab>
      <v-tab class="caption"> Open bets </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <bet-popover
          v-if="selectedBetfairId.id"
          :check-id="selectedBetfairId.id"
          :class="{ 'shake-now': shake }"
          class="hits-sticky"
        ></bet-popover>
      </v-tab-item>
      <v-tab-item>
        <my-bets class="hits-sticky"></my-bets>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import MyBets from '@/components/MyBets'
import BetPopover from '@/components/BetPopover'

export default {
  components: {
    MyBets,
    BetPopover
  },
  data() {
    return {
      refresh: true,
      shake: false,
      tabs: 1
    }
  },
  computed: {
    ...mapState({
      selectedBetfairId: (state) => state.placeBet.runner
    })
  },
  watch: {
    selectedBetfairId(v) {
      if (v) {
        if (this.tabs === 0 && v.id) {
          this.shake = true
          setTimeout(() => {
            this.shake = false
          }, 300)
        }
        if (v) {
          this.tabs = 0
        } else {
          this.tabs = 1
        }
        if (!v.id) {
          this.tabs = 1
        }
      }
    }
  },
  methods: {}
}
</script>
